import { Component, Inject, forwardRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'resync-actions-dialog',
    template: require('./resync-actions-dialog.component.html')
})
export class ResyncActionsDialogComponent {

    workingHours: number;
    simulatedWorkingHours: number;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<ResyncActionsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        this.workingHours = data.workingHours;
        this.simulatedWorkingHours = data.simulatedWorkingHours;
    }

    save(): void {
        this.dialogRef.close({ simulatedWorkingHours: this.simulatedWorkingHours });
    }

    reset(): void {
        this.dialogRef.close({ simulatedWorkingHours: null });
    }
}